import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { ButtonBase } from "../index.tsx";
import { Fragment } from "react";

type MobileSlideUpModalProps = {
  isOpen: boolean;
  handleCloseModal: () => void;
  isLoading?: boolean;
  title: string;
  description?: string;
  containerClass?: string;
  children: React.ReactNode;
  icon?: JSX.Element;
  disableXmark?: boolean;
  imgUrl?: string;
  descriptionWidth?: string;
  hideCrossMark?: boolean;
};

const MobileSlideUpModal = ({
  isOpen,
  isLoading,
  title,
  description,
  containerClass,
  children,
  disableXmark,
  handleCloseModal,
  icon,
  imgUrl,
  descriptionWidth,
  hideCrossMark = false,
}: MobileSlideUpModalProps) => {
  return (
    <Transition as={Fragment} appear show={isOpen}>
      <Dialog as="div" onClose={() => { }}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm" />
        </TransitionChild>
        <div className="fixed w-full bottom-0 overflow-y-auto z-50 ">
          <div className="flex items-center justify-center">
            <TransitionChild
              as={Fragment}
              enter="transform transition ease-out duration-300"
              enterFrom="translate-y-full"
              enterTo="translate-y-0"
              leave="transform transition ease-in duration-200"
              leaveFrom="translate-y-0"
              leaveTo="translate-y-full"
            >
              <DialogPanel
                className={`w-full bg-white rounded-t-2xl flex flex-col gap-4 shadow-xl border border-lightGray ${containerClass}`}
              >
                <section className="flex relative items-center justify-between gap-8 border-b border-extraLightGray p-4">
                  <div>
                    <h1 className="font-bold capitalize max-sm:text-base text-ellipsis flex gap-2 items-center ">
                      {icon}
                      {imgUrl ? (
                        <img
                          src={imgUrl}
                          className="h-8 w-8 max-sm:w-4"
                          alt="img.png"
                        />
                      ) : (
                        <></>
                      )}{" "}
                      {title}
                    </h1>
                    <p
                      className={`tw-sub-heading max-sm:hidden ${descriptionWidth}`}
                    >
                      {description}
                    </p>
                  </div>
                  {!hideCrossMark && (
                    <ButtonBase
                      icon={<XMarkIcon className="size-5" />}
                      buttonType="tertiary"
                      onClick={handleCloseModal}
                      disabled={disableXmark}
                    />
                  )}
                </section>
                {isLoading ? (
                  <div className="h-56 bg-lightGray rounded-lg animate-pulse" />
                ) : (
                  children
                )}
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default MobileSlideUpModal;
